import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useLanguage } from "../../../Components/LangTranslation/LanguageContext";
import { Helmet } from "react-helmet-async";
import { Form, Formik } from "formik";
import VerifyEmailStep from "./components/VerifyEmailStep";
import ShopInformationStep from "./components/ShopInformationStep";
import CreateWebsiteStep from "./components/CreateWebsiteStep";
import CRBannkAccountStep from "./components/CRBannkAccountStep";
import "./signup.css";
import verifyStepIcon from "../../../Images/verifyEmail.svg";
import shopStepIcon from "../../../Images/shopInfo.svg";
import websiteStepIcon from "../../../Images/createWebsite.svg";
import socialMediaIcon from "../../../Images/socialmediaIcon.svg";
import bankStepIcon from "../../../Images/crBankInfo.svg";
import finishStepIcon from "../../../Images/finishonb.svg";
import { checkApi } from "../../../DataApi/onboarding/checkApi";
import VerifyEmail from "../VerifyEmail/VerifyEmail";
import Modal from "../../../Components/Kanban/Modal/Modal";
import { onBoardingValidationSchema } from "../../../utilities/Validation Schema/OnBoardingValidationSchema";
import ErrorFocus from "../../../Components/Formik/ErrorFocus";
import FinishStep from "./components/FinishStep";
import AuthTopbar from "../../../Components/AuthTopbar/AuthTopbar";
import ButtonSpinLoader from "../../../Components/ButtonLoader/ButtonSpinLoader";
import { enqueueSnackbar } from "notistack";
import { getFilter } from "../../../utilities/get-filter";
import {
  backgroundColor,
  borderColor,
  primaryColor,
  textColor,
} from "../../../utilities/colors";
import { useSession } from "../../../authentications/SessionContext";
import SocialMediaStep from "./components/SocialMediaStep";

const onBoardingInitialValues = {
  // step 0
  email: "",
  business_name: "",
  domain_name: "",
  first_name: "",
  last_name: "",
  website_logo: "",
  website_hero_img: "",
  website_palette: [],
  website_name: "",
  domain: "",

  // step 2
  country: 171,
  state: "",
  city: "",
  street: "",
  zip: "",
  phone_prefix: "+968",
  phone: "",
  wilayat: "",
  governorate:"",

  // step 3
  acc_holder_name: "",
  account_number: "",
  account_number_exist: false,
  branch_name: "",
  bank_id: "",
  cr_file: "",
  cr: "",
  cc: "",
  vc: "",
  cr_number: "",
  iban: "",
  cr_expiry_date: "",
  vat_number: "",
  vat_expiry_date: "",
  isVat: "",

  //step 4
  insta_url: "",
  x_url: "",
  fb_url: "",
};

const SignUp = () => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const { sessionInfo } = useSession();
  const [activeTab, setActiveTab] = useState(0);
  const stepsList = [
    {
      title: t["Verify Email"],
      iconSvg: verifyStepIcon,
    },
    {
      title: t["Shop Information"],
      iconSvg: shopStepIcon,
    },
    {
      title: t["Pickup Address"],
      iconSvg: websiteStepIcon,
    },
    {
      title: t["Add Social Media"],
      iconSvg: socialMediaIcon,
    },
    {
      title: t["Document & bank information"],
      iconSvg: bankStepIcon,
    },
    {
      title: t["Finish"],
      iconSvg: finishStepIcon,
    },
  ];
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSkip, setIsLoadingSkip] = useState(false);
  const [governateOption, setGovernateOption] = useState([]);
  const [wilayatOption, setWilayatOption] = useState([]);
  const [cityOption, setCityOption] = useState([]);
  const [areaOption, setAreaOption] = useState([]);
  const [governateBOption, setGovernateBOption] = useState([]);
  const [wilayatBOption, setWilayatBOption] = useState([]);
  const [cityBOption, setCityBOption] = useState([]);
  const [areaBOption, setAreaBOption] = useState([]);
 

  const [isOTPLoading, setIsOTPLoading] = useState(false);
  const [leadId, setleadId] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [themeOptions, setThemeOptions] = useState([]);
  const [countriesOption, setCountriesOption] = useState([]);
  const [statesOption, setStatesOption] = useState([]);
  const [bankOptions, setBankOptions] = useState([]);
  const [invitationLink, setInvitationLink] = useState(null);
  const [openVerifyEmailModal, setOpenVerifyEmailModal] = useState(false);
  const navigate = useNavigate();
  const isSubmittingRef = useRef(false);

  const handleResendOTP = (values) => {
    checkApi({
      params: {
        name: `${values?.first_name?.trim()} ${values?.last_name?.trim()}`,
        email: values.email,
      },
      endpoint: "/onboarding/email/verify/send",
    }).then((emailResponse) => {
      handleCloseLoader();
      if (emailResponse?.result?.result?.lead_id) {
        setOpenVerifyEmailModal(true);
        setleadId(emailResponse?.result?.result?.lead_id);
      }
    });
  };
  const handleCloseLoader = () => {
    setIsLoading(false);
    setIsLoadingSkip(false);
  };
  const handleVerify = async (
    values,
    validateForm,
    setErrors,
    setFieldTouched
  ) => {
    setIsLoading(true);
    const resp = await validateForm(values);

    if (Object.keys(resp)?.length === 0) {
      const response = await Promise.all([
        checkApi({
          params: { user: values.email },
          endpoint: "/onboarding/user_check",
        }),
        checkApi({
          params: { domain: values.domain_name },
          endpoint: "/onboarding/domain_check",
        }),
      ]);
      const [userCheckResponse = {}, domainCheckResponse = {}] = response;

      if (domainCheckResponse?.result?.code === 403) {
        setErrors({
          domain_name: "This is a reserved word, cannot be used as Domain Name",
        });
        setFieldTouched("domain_name", true);
        handleCloseLoader();
        return;
      }
      if (userCheckResponse?.result?.result?.exists === true) {
        setErrors({ email: "Email Already Exist" });
        setFieldTouched("email", true);
        handleCloseLoader();
        return;
      }
      if (domainCheckResponse?.result?.result?.exists === true) {
        setErrors({ domain_name: "Domain Already Exist" });
        setFieldTouched("domain_name", true);
        handleCloseLoader();

        return;
      }
      handleResendOTP(values);
    } else {
      setErrors(resp);
      Object.keys(resp).forEach((key, index) => {
        setFieldTouched(key, true);
      });
      setIsLoading(false);
    }
  };
  const handleSkip = () => {
    return setActiveTab(activeTab + 1);
  };
  const handleBack = () => {
    return setActiveTab(activeTab - 1);
  };
  const handleNext = () => {
    return setActiveTab(activeTab + 1);
  };
  const handleFirstSignIn = () => {
    // console.log("handle first sign in", invitationLink);
    if (invitationLink) {
      window.location.href = invitationLink; // Redirects to the invitation link
    } else {
      console.error("No invitation link available");
      enqueueSnackbar(
        "If the login button doesn’t work, please check your email for the login link.",
        {
          variant: "error",
        }
      );
    }
  };
  const handleSignIn = () => {
    navigate("/signin");
  };
  const handleChangeCountry = (value) => {
    const governorateApi = checkApi({
      endpoint: "/onboarding/governorate",
      params: { country_id: value },
    });

    const statesApi = checkApi({
      endpoint: "/onboarding/states",
      params: { country_id: value },
    });

    Promise.all([governorateApi, statesApi]).then(([governates, states]) => {
      if (governates?.result?.result?.length > 0) {
        const governateOp = governates.result.result.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        setGovernateOption(governateOp || []);
      }

      if (states?.result?.result?.length > 0) {
        const statesOp = states.result.result.map((theme) => ({
          label: theme.name,
          value: theme.id,
          zip: theme.zip,
        }));
        setStatesOption(statesOp || []);
      }
    });
  };


  const onChangeGovernate = (value, type) => {
    checkApi({
      endpoint: "/onboarding/wilayat",
      params: {
        governorate_id: value,
      },
    }).then((wilayats) => {
      if (wilayats?.result?.result?.length > 0) {
        const wilayatOp = wilayats?.result?.result?.map((item) => ({
          label: item.name,
          value: item.id,
          // zip: theme.zip,
        }));
        if (type === "governate") {
          setWilayatOption(wilayatOp || []);
          console.log(wilayatOp,"dh");
          return;
        }
        // if (type === "governateB") {
        //   setWilayatBOption(wilayatOp || []);
        //   return;
        // }
      }
    });
  };


  const onChangeWilayat = (value, type) => {
    checkApi({
      endpoint: "/onboarding/city",
      params: {
        wilayat_id: value,
      },
    }).then((cities) => {
      if (cities?.result?.result?.length > 0) {
        const cityOp = cities?.result?.result?.map((item) => ({
          label: item.name,
          value: item.id,
          // zip: theme.zip,
        }));
        if (type === "wilayat") {
          setCityOption(cityOp || []);
          return;
        }
        // if (type === "wilayatB") {
        //   setCityBOption(cityOp || []);
        //   return;
        // }
      }
    });
  };

  const onChangeCity = (value, type) => {
    checkApi({
      endpoint: "/onboarding/area",
      params: {
        city_id: value,
      },
    }).then((areas) => {
      if (areas?.result?.result?.length > 0) {
        const areaOp = areas?.result?.result?.map((item) => ({
          label: item.name,
          value: item.id,
          // zip: theme.zip,
        }));
        if (type === "city") {
          setAreaOption(areaOp || []);
          return;
        }
        if (type === "cityB") {
          setAreaBOption(areaOp || []);
          return;
        }
      }
    });
  };
  
  const handleOTP = (otp) => {
    if (isOTPLoading) return;
    setIsOTPLoading(true);

    checkApi({
      params: {
        otp: otp,
        lead_id: leadId,
      },
      endpoint: "/onboarding/email/verify/otp",
    }).then((response) => {
      setIsOTPLoading(false);

      if (response?.result?.result?.success) {
        setOpenVerifyEmailModal(false);
        setIsVerified(true);
        handleNext();
      } else {
        enqueueSnackbar(response?.result?.result?.message, {
          variant: "error",
        });
      }
    });
  };
  const handleCreateNewCompany = async (values, getBank) => {
    const {
      first_name,
      last_name,
      email,
      phone_prefix,
      phone,
      business_name,
      domain,
      website_logo,
      website_hero_img,
      website_palette,
      website_name,
      country,
      state,
      wilayat,
      governate,
      city,
      area,
      street,
      zip,
      insta_url,
      x_url,
      fb_url,
      account_number,
    } = values;
    const params = {
      name: `${first_name} ${last_name}`,
      email,
      phone: phone_prefix + phone,
      lead_id: leadId,
      business_name,
      wilayat,
      governate,
      domain,
      website_logo,
      website_hero_img,
      website_palette,
      website_name,
      country,
      state,
      city,
      area,
      street,
      zip,
      insta_url,
      x_url,
      fb_url,
      account_number,
    };

    await checkApi({
      endpoint: "/onboarding/create_user_company_and_website",
      params,
    })
      .then((response) => {
        if (response.result?.code !== 400) {
          // setCompanyResponse(response.result?.result);
          setInvitationLink(response.result?.result?.user_invitation_link);
          if (getBank) {
            handleCreateCRBankAccount(values, response.result?.result);
          } else {
            handleNext();
          }
        } else {
          enqueueSnackbar(response.result.message, { variant: "error" });
        }
      })

      .catch((error) => {
        enqueueSnackbar("Something Went Wrong please Try Again", {
          variant: "error",
        });
      })
      .finally(() => {
        handleCloseLoader();
      });
  };
  const handleCreateCRBankAccount = async (values, companyResponse) => {
    const {
      acc_holder_name,
      account_number,
      iban,
      branch_name,
      bank_id,
      cr,
      cc,
      vc,
      cr_number,
      cr_expiry_date,
      vat_number,
      vat_expiry_date,
    } = values;
    const params = {
      acc_holder_name,
      account_number,
      iban,
      branch_name,
      bank_id,
      cr,
      cc,
      vc,
      cr_number,
      cr_expiry_date,
      vat_number,
      vat_expiry_date,
      user_id: companyResponse?.user_id,
      id: companyResponse?.company_id,
      // isVat: true,
    };
    // console.log("companyResponse", companyResponse);
    await checkApi({ params, endpoint: "/onboarding/crb" })
      .then((response) => {
        if (response.result?.code === 200) {
          handleNext();
        } else {
          enqueueSnackbar(response.result.message, { variant: "error" });
        }
      })
      .catch((error) => {
        enqueueSnackbar("Somthing Went Wrong Please Try Again", {
          variant: "error",
        });
      })
      .finally(() => {
        handleCloseLoader();
      });
  };
  const handleSubmit = async (values, event) => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    const clickedButton = event?.nativeEvent.srcElement.id;
    // console.log("args......", values, event, clickedButton);
    if (activeTab === 0) {
      isSubmittingRef.current = false;
      return;
    }
    if (activeTab === 4) {
      try {
        if (clickedButton === "skipBtn") {
          setIsLoadingSkip(true);
          await handleCreateNewCompany(values);
        } else {
          setIsLoading(true);
          const getBank = true;
          handleCreateNewCompany(values, getBank);
        }
      } catch (error) {
        console.error("Error during submission:", error);
      } finally {
        isSubmittingRef.current = false; // Always unlock after try-catch
      }
      return;
    }
    // handleCloseLoader();
    isSubmittingRef.current = false;
    handleNext();
  };
  useEffect(() => {
    checkApi({ endpoint: "/onboarding/theme_picker", params: {} }).then(
      (themes) => {
        const themesOp = themes?.result?.result?.map((theme) => ({
          label: theme.display_name,
          value: theme.id,
        }));
        // console.log("themeOp", themesOp);
        setThemeOptions(themesOp || []);
      }
    );
    checkApi({ endpoint: "/onboarding/countries", params: {} }).then(
      (countries) => {
        const countriesOp = countries?.result?.result?.map((country) => ({
          label: country.name,
          value: country.id,
          phone_code: country.phone_code,
        }));

        setCountriesOption(countriesOp || []);
      }
    );
    checkApi({ endpoint: "/onboarding/banks", params: {} }).then((banks) => {
      const bankOP = banks?.result?.result?.map((bank) => ({
        label: bank.name,
        value: bank.id,
      }));
      setBankOptions(bankOP || []);
    });
    handleChangeCountry(onBoardingInitialValues.country);
  }, []);

  return (
    <>
      <Helmet>
        <title>Sign-Up | iON Merchant Portal</title>
        <meta name="signup" />
      </Helmet>

      <AuthTopbar className="px-4 py-5" />

      <div className="fluidContainer">
        <div className="centeredColumn">
          <div className="titleWrapper">
            <h4 className="text-center signupTitle">{t["Getting Started"]}</h4>
            <p className="text-center signupSubTitle">
              {t["Create an account to continue!"]}
            </p>
          </div>
          <Title className="onboardingStepTitle">
            <h4 className="text-center signupTitle">
              {[
                "Verify Email",
                "Shop Information",
                "Pickup Address",
                "Add your Social Media",
                "Document & bank information",
              ][activeTab] || ""}
            </h4>
          </Title>
          <div className="w-100 my-3 linesWrapper">
            <hr
              className="orLines mx-2"
              style={{ backgroundColor: borderColor.primary }}
            />
            <hr
              className="orLines mx-2"
              style={{ backgroundColor: borderColor.primary }}
            />
          </div>
          <nav>
            <div
              className="nav nav-tabs border-0 justify-content-between"
              id="nav-tab"
              role="tablist"
            >
              {stepsList.map((tab, index) => (
                <Step
                  key={index}
                  role="button"
                  className={`onboarding-steps cursor-pointer justify-content-center align-items-center ${
                    activeTab >= index ? "active" : ""
                  }`}
                >
                  <img className="stepIcon" src={tab.iconSvg} alt="step-icon" />
                  <hr className="stepDivider" />
                  <p className="stepTitle font-bold">{tab.title}</p>
                </Step>
              ))}
            </div>
            <FormContainer>
              <Formik
                initialValues={{
                  ...onBoardingInitialValues,
                }}
                validationSchema={onBoardingValidationSchema(activeTab)}
                onSubmit={(values) => handleSubmit(values)}
              >
                {({
                  isSubmitting,
                  isValidating,
                  touched,
                  values,
                  errors,
                  validateForm,
                  setErrors,
                  setFieldTouched,
                }) => (
                  <Form className="row my-4">
                    {/* {console.log(errors, "errors")} */}
                    {/* {console.log(
                      "errors, values, touched",
                      errors,
                      values,
                      touched
                    )} */}
                    <Modal
                      isOpen={openVerifyEmailModal}
                      onClose={() => setOpenVerifyEmailModal(false)}
                    >
                      <VerifyEmail
                        handleOTP={handleOTP}
                        isOTPLoading={isOTPLoading}
                        handleResendOTP={handleResendOTP}
                      />
                    </Modal>
                    <div>
                      {activeTab < 5 ? (
                        <div className="row">
                          {activeTab === 0 && (
                            <VerifyEmailStep
                              setIsVerified={setIsVerified}
                              handleCloseLoader={handleCloseLoader}
                            />
                          )}

                          {activeTab === 1 && (
                            <ShopInformationStep themeOptions={themeOptions} />
                          )}
                          {activeTab === 2 && (
                            <CreateWebsiteStep
                              countriesOption={countriesOption}
                              governateOption={governateOption}
                              governateBOption={governateBOption}
                              wilayatOption={wilayatOption}
                              wilayatBOption={wilayatBOption}
                              cityOption={cityOption}
                              cityBOption={cityBOption}
                              areaOption={areaOption}
                              areaBOption={areaBOption}
                              statesOption={statesOption}
                              onChangeCountry={handleChangeCountry}
                              onChangeGovernate={onChangeGovernate}
                              onChangeWilayat={onChangeWilayat}
                              onChangeCity={onChangeCity}
                            />
                          )}
                          {activeTab === 3 && <SocialMediaStep />}
                          {activeTab === 4 && (
                            <CRBannkAccountStep
                              bankOptions={bankOptions}
                              handleCloseLoader={handleCloseLoader}
                            />
                          )}
                        </div>
                      ) : (
                        <FinishStep
                          email={values.email}
                          handleFirstSignIn={handleFirstSignIn}
                        />
                      )}
                    </div>

                    <div
                      className={`d-flex flex-md-row flex-column flex-wrap gap-2 justify-content-${
                        activeTab === 5 ? "center" : "between"
                      }`}
                    >
                      {activeTab === 0 && (
                        <div className="col-12 d-flex flex-wrap gap-1 ">
                          <button
                            type="submit"
                            className={`verifyBtn d-flex justify-content-center align-items-center  ${
                              isVerified ? "col-12 col-md-6" : "col-12"
                            }`}
                            style={{
                              backgroundColor: "#ff5837",
                              border: "1px solid #ff5837",
                              color: "#ffffff",
                            }}
                            disabled={isVerified || isLoading}
                            onClick={() =>
                              handleVerify(
                                values,
                                validateForm,
                                setErrors,
                                setFieldTouched
                              )
                            }
                          >
                            <ButtonSpinLoader isLoading={isLoading} />
                            {!isVerified ? t["Next"] : t["Verify"]}
                          </button>
                          {isVerified && (
                            <button
                              type="button"
                              className="nextBtn col-12 col-md-6"
                              style={{
                                backgroundColor: "#ff5837",
                                border: "1px solid #ff5837",
                                color: "#ffffff",
                              }}
                              onClick={() =>
                                handleNext(
                                  values,
                                  validateForm,
                                  setErrors,
                                  setFieldTouched
                                )
                              }
                            >
                              {t["Next"]}
                            </button>
                          )}
                        </div>
                      )}
                      {activeTab > 0 && activeTab < 5 && (
                        <>
                          {activeTab !== 3 && activeTab !== 4 && (
                            <>
                              <button
                                type="button"
                                className="backBtn col-md-6 col-12 twoBtnWidth"
                                style={{
                                  backgroundColor: "#cbcbcb",
                                }}
                                onClick={handleBack}
                              >
                                {t["Back"]}
                              </button>

                              <button
                                type="button"
                                disabled={isLoading}
                                className="nextBtn col-md-6 col-12 d-flex justify-content-center align-items-center"
                                style={{
                                  backgroundColor: "#ff5837",
                                  border: "1px solid #ff5837",
                                  color: "#ffffff",
                                }}
                                onClick={async (event) => {
                                  let checkValidate = await validateForm(
                                    values
                                  );
                                  if (
                                    Object.keys(checkValidate)?.length === 0
                                  ) {
                                    handleNext();
                                  } else {
                                    setErrors(checkValidate);
                                    Object.keys(checkValidate).forEach(
                                      (key, index) => {
                                        setFieldTouched(key, true);
                                      }
                                    );
                                  }
                                }}
                              >
                                <ButtonSpinLoader isLoading={isLoading} />
                                {t["Next"]}
                              </button>
                            </>
                          )}
                          {activeTab === 3 && (
                            <>
                              <button
                                type="button"
                                disabled={isLoading}
                                className="nextBtn col-md-6 col-12 d-flex justify-content-center align-items-center"
                                style={{
                                  backgroundColor: "#ff5837",
                                  border: "1px solid #ff5837",
                                  color: "#ffffff",
                                }}
                                onClick={async (event) => {
                                  let checkValidate = await validateForm(
                                    values
                                  );
                                  if (
                                    Object.keys(checkValidate)?.length === 0
                                  ) {
                                    handleNext();
                                  } else {
                                    setErrors(checkValidate);
                                    Object.keys(checkValidate).forEach(
                                      (key, index) => {
                                        setFieldTouched(key, true);
                                      }
                                    );
                                  }
                                }}
                              >
                                <ButtonSpinLoader isLoading={isLoading} />
                                {t["Add"]}
                              </button>
                              <button
                                type="button"
                                className="nextBtn col-md-6 col-12 twoBtnWidth"
                                style={{
                                  backgroundColor: "#cbcbcb",
                                }}
                                onClick={handleNext}
                              >
                                {t["Skip for now"]}
                              </button>
                            </>
                          )}
                          {activeTab === 4 && (
                            <>
                              <button
                                type="submit"
                                disabled={isLoading}
                                className="nextBtn col-md-6 col-12 d-flex justify-content-center align-items-center"
                                style={{
                                  backgroundColor: "#ff5837",
                                  border: "1px solid #ff5837",
                                  color: "#ffffff",
                                }}
                              >
                                <ButtonSpinLoader isLoading={isLoading} />
                                {t["Next"]}
                              </button>
                              <button
                                type="button"
                                id="skipBtn"
                                className="skipBtn col-md-6 col-12 d-flex justify-content-center align-items-center"
                                style={{
                                  backgroundcolor: "#ffffff",
                                  border: "1px solid #ff5837",
                                  color: "#4e5d78",
                                }}
                                onClick={async (event) => {
                                  await handleSubmit(values, event);
                                }}
                              >
                                <ButtonSpinLoader
                                  isColor={"rgb(78, 93, 120)"}
                                  isLoading={isLoadingSkip}
                                />
                                {t["Skip for now"]}
                              </button>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </Form>
                )}
              </Formik>
            </FormContainer>
            <div className="d-flex flex-wrap justify-content-center align-items-center my-4">
              {activeTab !== 5 && (
                <>
                  <p className="suggessionText text-center p-0 m-0">
                    {t["Already have an account?"]}
                  </p>
                  <div
                    role="button"
                    className="suggessionBtn cursor-pointer"
                    onClick={handleSignIn}
                    style={{ color: "#ff5837" }}
                  >
                    {t["Sign In"]}
                  </div>
                </>
              )}
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};
export default SignUp;

//styled components
const FormContainer = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 20px;

  .form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    height: 56px !important;
    font-weight: 400;
    line-height: 1.5;
    color: #4e5d78 !important; /* else case */
    background-color: #f5f5f5;
    background-clip: padding-box;
    border: 1px solid #cbcbcb !important; /* else case */
    border-radius: 13px;

    &:focus {
      box-shadow: 0 0 0 0.1rem #ff5837;
      border: none;
      outline: none !important;
    }
  }

  .nav-tabs .nav-item.show .nav-link,
  .nav-tabs .nav-link.active {
    color: #ff5837 !important;
    background-color: #f5f5f5;
    border-color: #f5f5f5 #f5f5f5 #ff5837;
  }

  .nav-tabs .nav-link {
    font-family: "Inter" !important;
    font-weight: 600;
    color: #cbcbcb !important; /* else case */
  }

  .domain-input:focus {
    box-shadow: 0 0 0 0.1rem #ff5837;
  }
`;

const Step = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  min-height: 120px;
  height: auto;
  max-width: 100%;
  padding: 10px 0;
  img {
    height: 35px;
    width: 35px;
  }

  .stepTitle {
    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.2;
    text-align: center;
    height: 50px;
    display: block;
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: normal;
    max-width: 100%;
    margin: 0; /* Remove margin from p tag to prevent additional space */
    word-wrap: break-word; /* Ensure words break properly */
    overflow: hidden; /* Ensure no overflow of text */
  }
  &.active {
    color: ${(props) => (props.isVTEX ? "#BAF76A" : "#ff5837")}; /* else case */

    img {
      filter: ${getFilter("#ff5837")};
    }

    hr {
      color: #ff5837;
    }
  }
`;

const Title = styled.div`
  justify-content: center;
  align-items: center;
  width: 100%;
`;
